import { ReactElement, useEffect, useState } from 'react'
// @ts-ignore
import currencyFormatter from 'currency-formatter'
import { useNavigate, useMatches, useParams } from 'react-router-dom'
import { useAuth, useGuard } from '../../hooks/auth'
import { LOCAL_EXECUTION } from '../../utils/featureFlag'
import {
  Container,
  FormDivider,
  PageSubtitle,
  PageTitle,
  TextHeaderBox,
  ExceptionContainer,
  FirstStepButtonBox,
  Divider50,
  Divider25,
  ButtonDescription,
  ContainerButtons,
  ContainerCard,
  DetailCard,
  MobileDesktopControl,
  LabelCard,
  IconDetailContainer,
  BalanceAvailable,
  BalanceAvailableLabel,
  BalanceLabel,
  BalanceValue,
  BalanceAvailableIcon,
  BalanceAvailableButton,
  ButtonHeaderBox,
  PageHeaderBox,
  PageEventName,
} from './styles'

import {
  DashboardAlertMessage,
  DashboardhMediumButton,
  Icon,
} from 'bd-web-components'
// @ts-ignore
import Loader from '../../components/Loader'
import { getDashColor } from '../../styles'
import {
  BLACK,
  WHITE,
} from 'bd-web-components/src/utils/dash-colors'
//@ts-ignore
import { useBalanceDistribution } from '../../hooks/balance-distribution'
import {
  AdvanceBalanceDistributionProps,
  useAdvanceBalanceDistribution,
} from '../../hooks/advance-balance-distribution'
import { useHasAccess } from '../../hooks/auth'
import { errorRedirect } from '../../utils/redirect'
import { useEvent } from '../../hooks/events'
import { Breadcrumb } from '../../components/Breadcrumb'
import { truncateString } from '../../utils/string-modeling'
import { EventDebitsCard } from '../../components/EventDebitsCard'
import { EventDebits } from '../../types/event-debits'

export function WithdrawList(): ReactElement {
  window.document.title = 'Solicitar Saque'
  const { id } = useParams<{ id: string }>()
  const authContext = useAuth()
  const navigate = useNavigate()
  const { authHookWithEvent } = authContext

  // verify if user has this event
  if (!LOCAL_EXECUTION) {
    authHookWithEvent(id!, navigate)
  }

  // verify if user has permission to acess
  useGuard(['DP3', 'DP4', 'DP5', 'DP6'])

  // -------------------------------------------------------
  type BalanceDataProps = {
    status: boolean
    message: string
    totalValue: string
  }

  const [balanceData, setBalanceData] = useState<BalanceDataProps>({
    status: true,
    message: '-',
    totalValue: '-',
  })

  const [advanceLimits, setAdvanceLimits] =
    useState<AdvanceBalanceDistributionProps[] | null>(null)
  const [eventDebits, setEventDebits] = useState<EventDebits | undefined>(
    undefined
  )
  const [availableBalance, setAvailableBalance] = useState<number>(0)
  const balanceDistribution = useBalanceDistribution(Number(id), true)
  const advanceBalanceDistribution = useAdvanceBalanceDistribution(
    Number(id),
    true
  )

  let matches = useMatches()
  let crumbs = matches
    .filter((match: any) => Boolean(match.handle?.crumb))
    .map((match: any) => {
      return {
        name: match.handle.crumb(match.data),
        path: match.pathname,
      }
    })

  useEffect(() => {
    if (balanceDistribution.balance !== undefined) {
      setBalanceData({
        status: balanceDistribution.balance.data.body.avaliable,
        message: balanceDistribution.balance.data.body.message!,
        totalValue: currencyFormatter.format(
          balanceDistribution.balance.data.body.totalValue,
          { code: 'BRL' }
        ),
      })
      setEventDebits(balanceDistribution.balance.data.body.eventDebits)
      setAvailableBalance(balanceDistribution.balance.data.body.totalValue)
    }
    if (balanceDistribution.isError) {
      const data = balanceDistribution.isError.response?.data as {
        message: string
      }
      errorRedirect(
        '/error',
        {
          message: data?.message,
          tittle: 'Não permitido',
        },
        navigate
      )
    }
  }, [balanceDistribution.balance, balanceDistribution.isError, navigate])

  useEffect(() => {
    if (advanceBalanceDistribution.balance !== undefined) {
      const data = advanceBalanceDistribution.balance.data.data.balance
      setAdvanceLimits(data)
    }
  }, [advanceBalanceDistribution])

  const { event } = useEvent(Number(id))

  console.log(event, '@')

  const advanceValue =
    advanceLimits !== null
      ? advanceLimits[0].advanceLimit + advanceLimits[1].advanceLimit
      : 0
  const advanceBalance =
    advanceLimits !== null
      ? currencyFormatter.format(advanceValue, { code: 'BRL' })
      : 'R$ 0,00'

  const accessRequestWithdraw =
    useHasAccess('DP3') &&
    (event?.clienteId === authContext?.user?.clienteId ||
      authContext?.user?.clienteId == null)
  const accessAddAcount = useHasAccess('DP5')
  const accessRequestWithdrawAdvance =
    useHasAccess('DP6') &&
    (event?.clienteId === authContext?.user?.clienteId ||
      authContext?.user?.clienteId == null)
  const accessFinancialClosing = useHasAccess('DP7')
  const accessReceiptsCalendar = useHasAccess('DP17')

  const eventName = truncateString(event?.nome, 30)

  return (
    <>
      <Container>
        <Breadcrumb paths={crumbs} />
        <PageHeaderBox>
          <TextHeaderBox>
            <PageTitle>{'Solicitar Saque'}</PageTitle>
            <PageEventName>{eventName}</PageEventName>
            <PageSubtitle>
              {'Solicite o saque do seu evento de forma simplificada.'}
            </PageSubtitle>
          </TextHeaderBox>
          <ButtonHeaderBox>
            {accessFinancialClosing && (
              <DashboardhMediumButton
                onClick={() => navigate(`/events/${id}/financial`)}
                color="#fff"
                background={getDashColor('SECONDARY_BLUE_01', 'GRAY_DARK')}
                height="48px"
                maxWidth="100%"
                variant="contained"
                width="204px"
                borderRadius='100px'
              >
                {'Fechamento do Evento'}
              </DashboardhMediumButton>
            )}
          </ButtonHeaderBox>
        </PageHeaderBox>
        <FormDivider />
        <br />
        {!balanceData.status && (
          <DashboardAlertMessage
            mainMessage={'Saque indisponível!'}
            subMessage={balanceData.message}
            iconName="report"
          />
        )}
        <br />
        {!balanceDistribution.isLoading &&
          balanceData.status &&
          !advanceBalanceDistribution.isLoading && (
            <>
              <MobileDesktopControl>
                <BalanceAvailableButton>
                  <BalanceAvailableLabel>
                    Saldo Disponível
                    <BalanceAvailableIcon>
                      <Icon
                        width={10}
                        height={10}
                        iconName={'rightArrow'}
                        fill={BLACK}
                        classes="text-right"
                      />
                    </BalanceAvailableIcon>
                  </BalanceAvailableLabel>
                  <BalanceAvailable>{balanceData.totalValue}</BalanceAvailable>
                </BalanceAvailableButton>
                <Divider25 />
                <BalanceLabel>
                  Saldo para Antecipar:
                  <BalanceValue>{advanceBalance}</BalanceValue>
                </BalanceLabel>
                {accessRequestWithdraw && (
                  <FirstStepButtonBox>
                    <DashboardhMediumButton
                      //@ts-ignore
                      type="button"
                      disabled={!balanceData.status}
                      onClick={() =>
                        navigate(`/events/${id}/withdraw/requests/new`)
                      }
                      background={getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR')}
                      color={WHITE}
                      height="52px"
                      maxWidth="100%"
                      variant={'contained'}
                      borderRadius='100px'
                    >
                      <ButtonDescription>Solicitar Saque</ButtonDescription>
                    </DashboardhMediumButton>
                  </FirstStepButtonBox>
                )}
              </MobileDesktopControl>
              <MobileDesktopControl className="mobile-only">
                <BalanceAvailableButton>
                  <BalanceAvailableLabel>
                    Saldo Disponível
                    <BalanceAvailableIcon>
                      <Icon
                        width={10}
                        height={10}
                        iconName={'rightArrow'}
                        fill={BLACK}
                        classes="text-right"
                      />
                    </BalanceAvailableIcon>
                  </BalanceAvailableLabel>
                  <BalanceAvailable>{balanceData.totalValue}</BalanceAvailable>
                </BalanceAvailableButton>
                <br />
                {accessRequestWithdrawAdvance && balanceData.status && (
                  <FirstStepButtonBox>
                    <DashboardhMediumButton
                      //@ts-ignore
                      type="button"
                      disabled={!balanceData.status}
                      onClick={() =>
                        navigate(`/events/${id}/withdraw/requests/new`)
                      }
                      background={getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR')}
                      color={WHITE}
                      height="52px"
                      maxWidth="100%"
                      variant={'contained'}
                      borderRadius='100px'
                    >
                      <ButtonDescription>Solicitar Saque</ButtonDescription>
                    </DashboardhMediumButton>
                  </FirstStepButtonBox>
                )}
                <BalanceAvailableButton>
                  <BalanceAvailableLabel>
                    Saldo para Antecipar
                    <BalanceAvailableIcon>
                      <Icon
                        width={10}
                        height={10}
                        iconName={'rightArrow'}
                        fill={BLACK}
                        classes="text-right"
                      />
                    </BalanceAvailableIcon>
                  </BalanceAvailableLabel>
                  <BalanceAvailable>{advanceBalance}</BalanceAvailable>
                </BalanceAvailableButton>
                <br />
                {accessRequestWithdraw && (
                  <FirstStepButtonBox>
                    <DashboardhMediumButton
                      //@ts-ignore
                      type="button"
                      disabled={!balanceData.status}
                      onClick={() =>
                        navigate(`/events/${id}/withdraw/requests/advance`)
                      }
                      background={getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR')}
                      color={WHITE}
                      height="52px"
                      maxWidth="100%"
                      variant={'contained'}
                      borderRadius='100px'
                    >
                      <ButtonDescription>Antecipar</ButtonDescription>
                    </DashboardhMediumButton>
                  </FirstStepButtonBox>
                )}
              </MobileDesktopControl>
              {eventDebits !== undefined && (
                <EventDebitsCard
                  debits={eventDebits}
                  availableBalance={availableBalance}
                />
              )}
              <Divider50 />
              <ContainerButtons>
                {accessAddAcount && (
                  <>
                    <ContainerCard
                      onClick={() =>
                        navigate(`/finance/add-account?transactionType=TED`)
                      }
                    >
                      <DetailCard>
                        <IconDetailContainer>
                          <div>
                            <Icon
                              fill={getDashColor('SECONDARY_BLUE_01', 'WHITE')}
                              classes="question-circle-help-center"
                              iconName="businessBank"
                              width={18}
                              height={18}
                            />
                          </div>
                        </IconDetailContainer>
                      </DetailCard>
                      <LabelCard>Adicionar Conta Bancária</LabelCard>
                    </ContainerCard>

                    <ContainerCard
                      onClick={() =>
                        navigate(`/finance/add-account?transactionType=PIX`)
                      }
                    >
                      <DetailCard>
                        <IconDetailContainer>
                          <div>
                            <Icon
                              fill={getDashColor('SECONDARY_BLUE_01', 'WHITE')}
                              classes="question-circle-help-center"
                              iconName="pix"
                              width={18}
                              height={18}
                            />
                          </div>
                        </IconDetailContainer>
                      </DetailCard>
                      <LabelCard>Adicionar Chave PIX</LabelCard>
                    </ContainerCard>
                  </>
                )}
                <MobileDesktopControl>
                  {accessRequestWithdrawAdvance && balanceData.status && (
                    <ContainerCard
                      onClick={() =>
                        navigate(`/events/${id}/withdraw/requests/advance`)
                      }
                    >
                      <DetailCard>
                        <IconDetailContainer>
                          <div>
                            <Icon
                              fill={getDashColor('SECONDARY_BLUE_01', 'WHITE')}
                              classes="question-circle-help-center"
                              iconName="businessWithdrawal"
                              width={18}
                              height={18}
                            />
                          </div>
                        </IconDetailContainer>
                      </DetailCard>
                      <LabelCard>Antecipar</LabelCard>
                    </ContainerCard>
                  )}
                </MobileDesktopControl>
                {accessReceiptsCalendar && (
                  <ContainerCard
                    onClick={() =>
                      navigate(`/events/${id}/withdraw/requests/calendar`)
                    }
                  >
                    <DetailCard>
                      <IconDetailContainer>
                        <div>
                          <Icon
                            fill={getDashColor('SECONDARY_BLUE_01', 'WHITE')}
                            classes="question-circle-help-center"
                            iconName="calendar"
                            width={18}
                            height={18}
                          />
                        </div>
                      </IconDetailContainer>
                    </DetailCard>
                    <LabelCard>Calendário de Recebimentos</LabelCard>
                  </ContainerCard>
                )}
              </ContainerButtons>
            </>
          )}
        {(balanceDistribution.isLoading ||
          advanceBalanceDistribution.isLoading) && (
            <ExceptionContainer height={400} margin={false}>
              <Loader />
            </ExceptionContainer>
          )}
      </Container>
    </>
  )
}
